//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * Original Author: Treg Anderson
 * Original Team: Mavericks
 */
import { VForm, VTextField } from 'vuetify/lib';
import { NsIcon } from '@nuskin/ns-icon';

export default {
  name: 'NsCvvForm',
  components: {
    NsIcon,
    VForm,
    VTextField,
  },
  props: {
    value: {
      type: String,
      default() {
        return '';
      },
    },

    buttonless: {
      type: Boolean,
      default() {
        return false;
      },
    },

    amex: {
      type: Boolean,
      default() {
        return false;
      },
    },

    translations: {
      type: Object,
      default() {
        return {
          continue: 'Continue',
          cvvLabel: 'CVV',
          fieldRequired: 'This field is required',
          cvvInvalid: 'CVV must be at least three digits',
        };
      },
    },
  },
  data() {
    return {
      cvv: this.value,
      rules: [],
      t: this.translations,
      maxLength: this.amex ? 4 : 3,
      tooltipClass: 'card-image-tooltip-left',
    };
  },
  watch: {
    translations() {
      this.t = this.translations;
      if (Object.keys(this.t).length > 0) {
        this.initRules();
      }
    },
    amex() {
      this.maxLength = this.amex ? 4 : 3;
    },
    value() {},
  },
  mounted() {
    this.initRules();
    document.addEventListener('click', () => {
      const cc = document.getElementById('creditCardImage');
      if (cc && cc.style.display === 'block') {
        cc.style.display = 'none';
      }
    });
    this.setCardImagePosition();
  },
  methods: {
    doContinue() {
      if (this.$refs.cvvForm.validate()) {
        this.$emit('input', this.cvv);
      }
    },

    cvvChanged(value) {
      if (this.buttonless) {
        const isValid = this.rules.reduce((valid, rule) => {
          return valid && typeof rule(value) !== 'string';
        }, true);
        this.$emit('input', isValid ? this.cvv : '');
      }
    },
    setCardImagePosition() {
      const rect = document.body.getBoundingClientRect();
      const elRect = document
        .getElementById('cc-tooltip')
        .getBoundingClientRect();
      if (elRect.left - rect.left > (rect.right - rect.left) / 2) {
        this.tooltipClass = 'card-image-tooltip-left';
      } else {
        this.tooltipClass = 'card-image-tooltip-right';
      }
    },
    showCreditCardImage(event) {
      event.stopPropagation();
      if (/Mobi|Android/i.test(navigator.userAgent)) {
        try {
          const cc = document.getElementById('creditCardImage');
          cc.style.display = cc.style.display === 'block' ? 'none' : 'block';
        } catch (err) {
          // console.log(`Failed to show credit card image ${err}`);
        }
      }
    },

    initRules() {
      this.rules = [
        (value) => !!value || this.t.fieldRequired || 'This field is required',
        (value) =>
          /^\d{3,4}$/.test(value) ||
          this.t.cvvInvalid ||
          'CVV must be at least three digits',
      ];
    },
  },
};
